<label
  class="hx-label__description"
  [class.hx-label--bold]="bold()"
  [attr.for]="for()"
  [style.text-align]="contentJustification()"
  [style.width]="validatedWidth()"
  [style.color]="color()"
  [style.font-weight]="labelFontWeightStyle()"
  [style.font-style]="labelFontStyle()"
  [style.text-decoration]="labelTextDecoration()"
  [style.font-size]="labelFontSizeStyle()">
  @if (description()) {
    <span class="hx-label__title" [innerHTML]="sanitizedDescription"></span>
  }
  @if (required()) {
    <span aria-hidden="true" class="hx-label-required">*</span>
  }
  @if (tooltip()) {
    <hx-icon
      fontIcon="info-circle"
      size="16"
      [class]="'hx-label__tooltip-icon hx-label__tooltip-icon--color-' + tooltipColor()"
      [hxTooltip]="tooltip()!"
      [position]="tooltipPosition()"
      [tooltipColor]="tooltipColor()"
      [style.margin-left]="'8px'"
      [style.vertical-align]="'middle'"
      [style.cursor]="'pointer'"></hx-icon>
  }
  @if (subtitle()) {
    <div
      class="hx-label__subtitle"
      [innerHTML]="sanitizedSubtitle"
      [style.font-weight]="subtitleFontWeightStyle()"
      [style.font-style]="subtitleFontStyle()"
      [style.text-decoration]="subtitleTextDecoration()"
      [style.font-size]="subtitleFontSizeStyle()"
      [style.color]="subtitleColor()"></div>
  }
</label>
